import { ReactElement } from "react";
import Head from "next/head";

import { MainLayout } from "@/containers/layout/LandingLayout";
import Hero from "@/components/about/Hero";
import TheOdds from "@/components/about/TheOdds";
import JoinUs from "@/components/about/JoinUs";

const About = () => {
  return (
    <>
      <Head>
        <title>About Keyzy&apos;s Mission to Make Home Ownership A Reality Again</title>
        <link rel="canonical" href="https://www.keyzy.com/about" />
        <meta
          name="description" key="description"
          content="We are on a mission to unlock home ownership in the UK with an innovative rent to buy solution to help turn home ownership into a reality."
        />
        <meta
          name="twitter:card"
          content="We are on a mission to unlock home ownership in the UK with an innovative rent to buy solution to help turn home ownership into a reality."
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/about" key="ogurl" />
        <meta property="og:image" content="/about/keyzy-meta-about.png" key="ogimage" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="We are on a mission to unlock home ownership in the UK"
        />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta
          property="og:title"
          content="About Keyzy's Mission to Make Home Ownership A Reality Again"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="We are on a mission to unlock home ownership in the UK with an innovative rent to buy solution to help turn home ownership into a reality."
          key="ogdesc"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://keyzy.com/" },
                { "@type": "ListItem", "position": 2, "name": "About", "item": "https://keyzy.com/about" },
              ],
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Keyzy",
              "url": "https://www.keyzy.com",
              "logo": "https://www.keyzy.com/keyzy-logo.png",
              "description": "We are on a mission to unlock home ownership in the UK with an innovative rent to buy solution to help turn home ownership into a reality.",
              "sameAs": ["https://twitter.com/keyzyhomes"],
            }),
          }}
        />
      </Head>

      <Hero />
      <TheOdds />
      <JoinUs />
    </>
  );
};

About.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout>{page}</MainLayout>;
};

export default About;
